export default __webpack_public_path__ + "static/media/brain.e9dfca76.jpg";